import { render, staticRenderFns } from "./MypageTicketTodayPane.vue?vue&type=template&id=38a98a41&scoped=true"
import script from "./MypageTicketTodayPane.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayPane.vue?vue&type=style&index=0&id=38a98a41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a98a41",
  null
  
)

export default component.exports